import { getEnv } from '../config';

const { publicPath } = getEnv();

export const HOME = `${publicPath}`;
export const RESEND = `/resend`;
export const DATAMART_OB = `/onboarding`;
export const INITIAL_FORM = `/initialForm`;
export const COMMERCE_FORM = `/commerce-form`;
export const PERSON_FORM = `/person-form`;
export const REPRESENTANT_FORM = `/representant-form`;
export const PERSON_DETAILS_FORM = `/person-details-form`;
export const DOCUMENT_FORM = `/document-form`;
export const NO_COMMERCIAL_ACTIVITY = `/no-commercial-activity`;
export const VALIDATE_AND_CREATE_PASSWORD = `/validate-and-createPassword`;
export const VALIDATE_AND_CREATE_PASSWORD_WITH_TOKEN = `/validate-and-create-password`;
export const VALIDATION_FORM = `/validation-form`;
export const VALIDATE_DATA_FORM = `/validate-data-form`;
export const VALIDATE_DATA_FORM_WITH_TOKEN = `/validate-data-form/:token`;
export const ACCOUNT_CREATED = `/account-created`;
export const LOGIN = `/login`;
export const FORGOT_PASSWORD = `/forgot-password`;
export const RESET_PASSWORD = `/reset-password`;
export const TRANSACTIONS = `/transactions`;
export const TRANSACTION_DETAIL = `/transactions-refund`;
export const DOCUMENT = `/configuration-documentation`;
export const FUNDS_OUT = `/funds-out`;
export const EMAIL_SENT = `/email-sent`;
export const DO_FUNDS_OUT = `/funds-out-do`;
export const SUCCESS_FUNDS_OUT = `/funds-out-success`;
export const SUCCESS_REFUND = `/transactions-refund-success`;
export const ERROR_REFUND = `/transactions-refund-error`;
export const WITHDRAW_ERROR = `/funds-out-error`;
export const SUCCESS_RESET_PASSWORD = `/success-reset-password`;
export const USERS = `/configuration-users`;
export const USER_DETAIL = `/configuration-users-detail`;
export const USER_EDIT = `/configuration-users-detail-edit`;
export const USER_INVITE_FORM = `/configuration-users-invite-form`;
export const USER_INVITE_ROLES = `/configuration-users-invite-roles`;
export const COMMERCE_DATA = `/configuration-commerce-info`;
export const EDIT_COMMERCE = `/configuration-commerce-info-edit`;
export const EDIT_REPRESENTANT = `/configuration-commerce-info-representant-edit`;
export const ADD_BANK_ACCOUNT = `/configuration-commerce-info-bank-account-add`;
export const EDIT_BANK_ACCOUNT = `/configuration-commerce-info-bank-account-edit`;
export const FUNDS_OUT_ADD_BANK_ACCOUNT = `/funds-out-bank-account-add`;
export const FUNDS_OUT_EDIT_BANK_ACCOUNT = `/funds-out-bank-account-edit`;
export const SETTLEMENT_CALENDAR = `/settlement-calendar`;
export const EDIT_ROLE = '/configuration-users-detail-edit-role';
export const EDIT_ROLE_ERROR = '/configuration-users-detail-edit-role-error';
export const EDIT_NAME = '/configuration-users-detail-edit-name';
export const EDIT_DOCUMENT_NUMBER = '/configuration-users-detail-edit-document-number';
export const EDIT_PHONE_NUMBER = '/configuration-users-detail-edit-phone-number';
export const SELLER_CREDIT_FACILITY = '/seller-credit-facility';
export const SELLER_HOME = '/home';
export const LAST_MOVEMENTS = `/last-movements`;
export const HELP = `/help`;
export const HELP_FPAY = `/help-fpay`;
export const HELP_FALABELLA = `/help-falabella`;
export const USER_RECOVERY = `/user-recovery`;
export const FINANCE = `/finance`;
export const FOUNDS_OUT_CHECK = `/funds-out-check`;
